import React from 'react';
import styles from './PrivacyPolicy.module.css';

const SECTIONS = [
  {
    num: '01',
    title: 'Introduction',
    content: (
      <p>VIN Fly Aviation Academy is committed to protecting the privacy of all students, applicants, and users. This Privacy Policy explains how we collect, use, and safeguard your information.</p>
    ),
  },
  {
    num: '02',
    title: 'Information We Collect',
    content: (
      <>
        <p>We may collect the following details:</p>
        <ul>
          <li>Full Name</li>
          <li>Contact Number</li>
          <li>Email Address</li>
          <li>Date of Birth</li>
          <li>Address</li>
          <li>Educational Documents</li>
          <li>Any information submitted through forms</li>
        </ul>
      </>
    ),
  },
  {
    num: '03',
    title: 'Use of Information',
    content: (
      <>
        <p>Your information is used for:</p>
        <ul>
          <li>Admission processing and verification</li>
          <li>Communication regarding courses and updates</li>
          <li>Academic tracking and attendance</li>
          <li>Training and placement assistance</li>
        </ul>
      </>
    ),
  },
  {
    num: '04',
    title: 'Data Protection',
    content: (
      <>
        <p>We ensure that:</p>
        <ul>
          <li>Your data is securely stored</li>
          <li>Unauthorized access is prevented</li>
          <li>Information is used only for official purposes</li>
        </ul>
      </>
    ),
  },
  {
    num: '05',
    title: 'Information Sharing',
    content: (
      <ul>
        <li>Data may be shared with internal staff and placement partners</li>
        <li>We do <strong>NOT</strong> sell or misuse personal data</li>
      </ul>
    ),
  },
  {
    num: '06',
    title: 'User Responsibility',
    content: (
      <ul>
        <li>Users must provide accurate and genuine information</li>
        <li>Providing false information is strictly prohibited</li>
      </ul>
    ),
  },
  {
    num: '07',
    title: 'Policy Updates',
    content: (
      <ul>
        <li>The academy reserves the right to update this policy anytime</li>
        <li>Users are responsible for reviewing updates</li>
      </ul>
    ),
  },
  {
    num: '08',
    title: 'Legal Jurisdiction',
    content: (
      <p>All disputes shall be subject to the jurisdiction of courts located in <strong>Pune, Maharashtra</strong> only.</p>
    ),
  },
  {
    num: '09',
    title: 'Authority',
    content: (
      <p>All policies are governed by <strong>VIN Fly Aviation Academy</strong> under <strong>VPB Education Foundation</strong>.</p>
    ),
  },
];

const PrivacyPolicy = () => (
  <main>
    {/* Hero */}
    <section className="page-hero" data-theme="dark">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(135deg, #0a1628 0%, #1a2a4a 60%, #0d1f3c 100%)', zIndex: 0 }} />
      {/* subtle grid overlay */}
      <div className={styles.heroGrid} />
      <div className="container page-hero__content" style={{ position: 'relative', zIndex: 1 }}>
        <p className="page-hero__breadcrumb">HOME / PRIVACY POLICY</p>
        <h1 className="page-hero__title">
          <span className="page-hero__title-top" style={{ color: '#FFFFFF', opacity: 1 }}>PRIVACY</span>
          <span className="page-hero__title-bottom" style={{ color: 'var(--cyan)' }}>POLICY.</span>
        </h1>
        <p className="page-hero__sub">How we collect, use, and protect your information.</p>
      </div>
    </section>

    {/* Intro badge */}
    <section className={styles.policySection}>
      <div className="container" style={{ maxWidth: 860 }}>
        <div className={styles.metaBadge}>
          <span className={styles.metaIcon}>🛡️</span>
          <div>
            <p className={styles.metaTitle}>VIN Fly Aviation Academy</p>
            <p className={styles.metaSub}>Under VPB Education Foundation &nbsp;·&nbsp; Effective: 2026</p>
          </div>
        </div>

        <div className={styles.sectionsWrap}>
          {SECTIONS.map((s) => (
            <div key={s.num} className={styles.policyCard}>
              <div className={styles.cardHeader}>
                <span className={styles.cardNum}>{s.num}</span>
                <h2 className={styles.cardTitle}>{s.title}</h2>
              </div>
              <div className={styles.cardBody}>{s.content}</div>
            </div>
          ))}
        </div>

        <p className={styles.footNote}>
          For questions about this policy, contact us at{' '}
          <a href="mailto:contact@vinaviation.com" className={styles.footLink}>contact@vinaviation.com</a>
        </p>
      </div>
    </section>
  </main>
);

export default PrivacyPolicy;
